import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import BoxWithTwoSections from 'components/BoxWithTwoSections';
import { transactionDetails as TEXT } from 'locales/en/transaction';

const FeeStructure = ({ transaction }) => {
  const schemeFeeType = useMemo(() => {
    if (!transaction.scheme_fee) {
      return 'N/A';
    }
    if (transaction.is_ic_scheme_fee_estimated) {
      return 'Estimated';
    }
    return 'Realized';
  }, [transaction.is_ic_scheme_fee_estimated, transaction.scheme_fee]);

  const leftSide = useMemo(
    () => ({
      amount: transaction.amountToDisplay,
      txtpay: transaction.txtPayFee,
      rebate: transaction.txtPayFeeRebate,
      processing: transaction.processingFee,
    }),
    [
      transaction.amountToDisplay,
      transaction.processingFee,
      transaction.txtPayFeeRebate,
      transaction.txtPayFee,
    ]
  );

  const rightSide = useMemo(
    () => ({
      schemeFee: transaction.schemeFee,
      net: transaction.netBalanceToDisplay,
      schemeFeeType,
    }),
    [schemeFeeType, transaction.netBalanceToDisplay, transaction.schemeFee]
  );

  return (
    <>
      <h2 className="text-javelin-gray-dark lg:text-xl text-base font-bold">
        {TEXT.feeStructure.header}
      </h2>
      <BoxWithTwoSections
        textObject={TEXT.feeStructure}
        data={{ left: leftSide, right: rightSide }}
      />
    </>
  );
};

FeeStructure.propTypes = {
  transaction: PropTypes.shape({}),
};
FeeStructure.defaultProps = {
  transaction: {},
};
export default FeeStructure;
